import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getPostLoginPath, hasWorkspaceAccess } from 'src/utils/navigation';

function GuestGuard({ children }) {
  const { user } = useSelector(state => state.account);

  if (user) {
    if (!hasWorkspaceAccess(user)) {
      return children;
    }
    return <Redirect to={getPostLoginPath(user)} />;
  }

  return children;
}

GuestGuard.propTypes = {
  children: PropTypes.any
};

export default GuestGuard;
